<template>
	<div :class="[isFullWidth ? 'lg:container' : '', customClass, fontColor]">
		<div :class="[isFullWidth ? 'flex justify-center pt-8' : '']">
			<div
				class="space-y-2"
				:class="[
					isFullWidth
						? 'text-xsm lg:w-3/4 lg:text-center xl:w-1/2'
						: 'text-xsm',
				]"
			>
				<slot />
			</div>
		</div>
	</div>
</template>

<script setup>
const props = defineProps({
	isFullWidth: {
		type: Boolean,
		default: true,
	},
	customClass: {
		type: String,
		default: '',
	},
	fontColor: {
		type: String,
		default: 'text-gray-575',
	},
})
</script>
